var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M6.947 20.123V17.25C5.148 15.883 4 13.8 4 11.464 4 7.342 7.582 4 12 4c4.419 0 8 3.342 8 7.464s-3.581 7.465-8 7.465c-.824 0-1.62-.117-2.368-.333l-2.685 1.527zm-.116-6.135l4.315-4.568 2.07 2.117L17.1 9.42l-4.29 4.568-2.051-2.154-3.927 2.154z",
    clipRule: "evenodd"
  }));
}
export default SvgIconMessenger;